// src/utils.js

import React from 'react'; // Needed for JSX if not implicitly available
import {
  FaSun,
  FaCloudRain,
  FaCloud,
  FaCloudSun,
  FaMoon,
  FaCloudMoon,
  FaBolt,
  FaSmog
  // FaWind and FaLocationArrow are used directly in BBQWeatherIndex.js JSX, not in getWeatherConditionIcon
} from "react-icons/fa";

// OWM provides timezone as a UTC offset in seconds (not an IANA name), so
// Intl.DateTimeFormat can't be used directly. We add the offset to the current
// UTC timestamp and read getUTCHours() — correct for the location's civil time,
// including DST (OWM bakes the current DST offset into the timezone field).
export const getLocalHour = (timezoneOffsetSeconds) => {
  const localDate = new Date(Date.now() + timezoneOffsetSeconds * 1000);
  return localDate.getUTCHours();
};

export const getDynamicBorderColor = (score) => {
  const startR = 200; // Softer red
  const startG = 50;
  const startB = 50;
  const endR = 255; // Softer yellow
  const endG = 255;
  const endB = 150;
  const scoreRatio = score / 100;
  const r = Math.round(startR + (endR - startR) * scoreRatio);
  const g = Math.round(startG + (endG - startG) * scoreRatio);
  const b = Math.round(startB + (endB - startB) * scoreRatio);
  return `rgb(${r}, ${g}, ${b})`;
};

export const getWeatherConditionIcon = (condition, isDaytime, descriptionString) => {
  const iconSize = 40;
  const localDescription = descriptionString ? descriptionString.toLowerCase() : '';

  switch (condition) {
    case "Thunderstorm":
      return <FaBolt color="#FFD700" size={iconSize} />;
    case "Drizzle":
    case "Rain":
      return <FaCloudRain color="#6495ED" size={iconSize} />;
    case "Snow":
      return <FaCloud color="#ADD8E6" size={iconSize} />;
    case "Mist":
    case "Smoke":
    case "Haze":
    case "Dust":
    case "Fog":
    case "Sand":
    case "Ash":
    case "Squall":
    case "Tornado":
      return <FaSmog color="#A9A9A9" size={iconSize} />;
    case "Clear":
      return isDaytime ? <FaSun color="#FFD700" size={iconSize} /> : <FaMoon color="#E0FFFF" size={iconSize} />;
    case "Clouds":
      if (localDescription.includes("few clouds") || localDescription.includes("scattered clouds")) {
        return isDaytime ? <FaCloudSun color="#B0C4DE" size={iconSize} /> : <FaCloudMoon color="#B0C4DE" size={iconSize} />;
      } else if (localDescription.includes("broken clouds") || localDescription.includes("overcast clouds")) {
        return <FaCloud color="#778899" size={iconSize} />;
      }
      return <FaCloud color="#C0C0C0" size={iconSize} />; // Default for "Clouds" if no specific description
    default:
      return <FaCloud color="#F8F8F8" size={iconSize} />; // Default for unknown conditions
  }
};